import { mapGetters } from 'vuex'
import { isEqual, isEmpty } from 'lodash'
import helpers from '@/mixins/helpers'
export default {
  mixins: [ helpers ],
  props: {
    required: Boolean,
    rules: Array
  },
  data () {
    return {
      messages: []
    }
  },
  computed: {
    ...mapGetters(['_inputTypes']),
    internalLabel () {
      // let label = this._templateLiteralString(this.$attrs.label)
      let label = this.$attrs.label
      return !this.required ? `${label || ''} (optional)` : label || ''
    },
    internalRules () {
      return this.required
        ? [ this.requiredRule ].concat(this.additionalRules || []).concat(this.rules || [])
        : [].concat(this.additionalRules || []).concat(this.rules || [])
    },
    returnObject () {
      return this.$attrs['return-object'] !== undefined
    },
    evaluatedRules () {
      return this.internalRules.map(r => r(this.lazyValue))
    }
  },
  mounted () {
  },
  methods: {
    valueValid (v) {
      return !(v === undefined || v === null || v === '')
    },
    focus () {
      this.$refs.input.focus()
    },
    selectRequiredRule (v) {
      return this.hasValue(v) || `${this.$attrs.label || 'This field'} is required`
    },
    hasValue (v) {
      if (v === undefined || v === null) return false
      if (v.constructor === String) return this.valueValid(v)
      if (v.constructor === Array) return (v || []).length > 0
      if (v.constructor === Object) return !isEmpty(v)
      return false
    },
    isObject (v) {
      if (!v) return false
      return v.constructor === Object
    }
    // evaluateRules () {
    //   this.messages = this.internalRules.map(r => r(this.lazyValue)).filter(v => v !== true)
    // }
  },
  watch: {
    '$attrs.items' (v, ov) {
      if (!isEqual(v, ov)) {
        this.$nextTick(() => {
          let isValid = false
          v.forEach(i => {
            if (this.returnObject) {
              if (isEqual(i, this.internalValue)) isValid = true
            } else {
              if (isEqual(i.value, this.internalValue)) isValid = true
            }
          })
          if (!isValid) {
            let empty = this.returnObject ? {} : null
            this.internalValue = empty
            this.$emit('input', empty)
            this.$emit('change', empty)
            this.$nextTick(() => {
              this.$refs.input.resetValidation()
            })
          }
        })
      }
    }
  }
}
